var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "47px",
    viewBox: "0 0 68 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Diploma") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1222.000000, -126.000000)",
    stroke: "#043F93",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Diploma",
    transform: "translate(1223.000000, 127.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1568",
    strokeLinecap: "round",
    x: 0,
    y: 0,
    width: 66,
    height: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71428571,31.9736842 L4.71428571,13.0263158 C8.61972787,13.0263158 11.7857143,9.84518112 11.7857143,5.92105263 C11.7857143,5.51757765 11.7522443,5.1219574 11.6879418,4.73684211 L54.3120582,4.73684211 C54.2477557,5.1219574 54.2142857,5.51757765 54.2142857,5.92105263 C54.2142857,9.84518112 57.3802721,13.0263158 61.2857143,13.0263158 L61.2857143,31.9736842 C57.3802721,31.9736842 54.2142857,35.1548189 54.2142857,39.0789474 C54.2142857,39.4824224 54.2477557,39.8780426 54.3120582,40.2631579 L11.6879418,40.2631579 C11.7522443,39.8780426 11.7857143,39.4824224 11.7857143,39.0789474 C11.7857143,35.1548189 8.61972787,31.9736842 4.71428571,31.9736842 Z",
    id: "Rectangle-1569",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3214286,16.5789474 L49.5203147,16.5789474",
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0357143,27.2368421 L44.7857143,27.2368421",
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0357143,33.1578947 L44.7857143,33.1578947",
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1071429,11.8421053 L38.8928571,11.8421053",
    id: "Line",
    strokeLinecap: "square"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/Education.7e7a5ff3cc75837a44e261bb9a485765.svg";
export { ForwardRef as ReactComponent };